import { Button, CloseButton, Modal } from "react-bootstrap";
import TokuteishohyokiMain from "../TokuteishohyokiMain";

const TokuteishohyokiModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
      }}
      size="lg"
    >
      <Modal.Body>
        <CloseButton style={{ float: "right" }} onClick={handleClose} />
        <TokuteishohyokiMain />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" className="w-100" onClick={handleClose}>
          閉じる
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TokuteishohyokiModal;
